export enum MainAxisAlignment {
  start = 1,
  end,
  center,
  spaceBetween,
  spaceAround,
  spaceEvenly,
}
